module.exports = "/_next/static/images/f55a30c4579311a5ce09fa3ff01712af-phone-and-card@xs-1x.jpg.webp";